export default "__VITE_ASSET__bbd9b069__"